/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	Faculty,
	FacultyFromJSON,
	FacultyFromJSONTyped,
	FacultyToJSON,
} from "./Faculty";
import {
	Internship,
	InternshipFromJSON,
	InternshipFromJSONTyped,
	InternshipToJSON,
} from "./Internship";

/**
 *
 * @export
 * @interface FacultyInternship
 */
export interface FacultyInternship {
	/**
	 *
	 * @type {string}
	 * @memberof FacultyInternship
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof FacultyInternship
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof FacultyInternship
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyInternship
	 */
	internshipId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyInternship
	 */
	facultyId?: string;
	/**
	 *
	 * @type {number}
	 * @memberof FacultyInternship
	 */
	year?: number;
	/**
	 *
	 * @type {Internship}
	 * @memberof FacultyInternship
	 */
	internship?: Internship;
	/**
	 *
	 * @type {Faculty}
	 * @memberof FacultyInternship
	 */
	faculty?: Faculty;
}

export function FacultyInternshipFromJSON(json: any): FacultyInternship {
	return FacultyInternshipFromJSONTyped(json, false);
}

export function FacultyInternshipFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyInternship {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		internshipId: !exists(json, "internshipId")
			? undefined
			: json["internshipId"],
		facultyId: !exists(json, "facultyId") ? undefined : json["facultyId"],
		year: !exists(json, "year") ? undefined : json["year"],
		internship: !exists(json, "internship")
			? undefined
			: InternshipFromJSON(json["internship"]),
		faculty: !exists(json, "faculty")
			? undefined
			: FacultyFromJSON(json["faculty"]),
	};
}

export function FacultyInternshipToJSON(value?: FacultyInternship | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		internshipId: value.internshipId,
		facultyId: value.facultyId,
		year: value.year,
		internship: InternshipToJSON(value.internship),
		faculty: FacultyToJSON(value.faculty),
	};
}
